import { useBreakpointValue } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import DesktopFiltersBar from './DesktopFiltersBar';
import MobileFiltersBar from './MobileFiltersBar';

const propTypes = {
  sortByValue: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
  onSortByChange: PropTypes.func.isRequired,
  sortingOptions: PropTypes.array,
  adFilterValue: PropTypes.bool,
  onAdFilterChange: PropTypes.func,
  tagsValue: PropTypes.arrayOf(PropTypes.string),
  onTagsChange: PropTypes.func,
  startDate: PropTypes.any,
  endDate: PropTypes.any,
  onDatesChange: PropTypes.func.isRequired,
};

const RecentContentFiltersBar = (props) => {
  const isMobileView = useBreakpointValue({ base: true, md: false });

  return isMobileView ? (
    <MobileFiltersBar {...props} />
  ) : (
    <DesktopFiltersBar {...props} />
  );
};

RecentContentFiltersBar.propTypes = propTypes;

export default RecentContentFiltersBar;
